import {
	BackdropCircularProgress,
	DownloadFileButton,
	EnhancedButtonPrimeReact,
	EnhancedButtonPrimeReactSeverity,
	EnhancedSnackbar,
	IResponse,
	IServerError,
	ImportSlipsInstructions,
} from "@websential/cosmic-v20";
import { Box, Button, Card, Grid, Paper, Typography } from "@mui/material";
import { EXCEL_EMP_FILE_BASE64, EXCEL_VENDOR_FILE_BASE64 } from "./constants";
import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { createStyles, makeStyles, useTheme } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { useMutation, useQuery } from "@tanstack/react-query";

import DownloadIcon from "@mui/icons-material/Download";
import { EmployeeService } from "../../services/EmployeeService";
import { EnhancedSnackbarForLinkMessage } from "../EnhancedSnackbarForLinkMessage";
import ForwardIcon from "@mui/icons-material/Forward";
import { IAppState } from "../../store/reducers";
import { INITIAL_SNACKBAR_DATA } from "../../common/constants";
import { saveXlsxAsFile } from "../../common/Common";
import { setSelectedCSVInformationUI } from "../../store/actions/CSVInformationUIAction";
import { setSelectedDrawerOptionsMenu } from "../../store/actions/drawerMenuOptionsActions";
import { setSelectedStickyNavBar } from "../../store/actions";
import { useParams } from "react-router-dom";

const instructionTitle = "Instructions";
const instructionSubTitle = "File Instructions";
const useGetPayFrequencyDDL = (clientId: string, taxYear: number) =>
	useQuery({
		queryKey: ["pay-frequency-ddl"],
		queryFn: (data) => {
			return EmployeeService.getPayFrequencyDDL(clientId, taxYear);
		},
		refetchOnWindowFocus: false,
	});
const EmployeeImportLayout = () => {
	const theme = useTheme();
	const [selectedFile, setSelectedFile] = useState(EXCEL_EMP_FILE_BASE64);
	const [snackbarData, setSnackbarData] = useState(INITIAL_SNACKBAR_DATA);
	const [isLoading, setIsLoading] = useState(false);
	const id = useSelector((state: IAppState) => state.client.id);
	const clientId = useSelector((state: IAppState) => state.client.id);
	const taxYear = useSelector((state: IAppState) => state.taxYear.year);
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const instructionList = [
		{ icon: ForwardIcon, text: "Download sample excel file." },
		{ icon: ForwardIcon, text: `Fill Employee data as per headings defined.` },
		{ icon: ForwardIcon, text: "Delete sample record." },
		{ icon: ForwardIcon, text: "Save As CSV (Comma delimited) (*.csv)." },
		{
			icon: ForwardIcon,
			text: "Upload the file for import and Press Retrive Data Button.",
		},
		{ icon: ForwardIcon, text: "Maximum allowed file size is one MB." },
	];

	const { isPending: isPendingPayFrequencyDDL, data: payFrequencyDDLItems } =
		useGetPayFrequencyDDL(clientId, taxYear);

	const handleFileChange = (event: any) => {
		const file = event.target.files[0];
		setSelectedFile(file);
	};

	const handleSubmit = (event: any) => {
		event?.preventDefault();
		const formData = new FormData();
		formData.append("file", selectedFile);

		console.log('selectedFile', selectedFile)
		console.log('formData', formData)
		let payload = {
			id,
			formData,
		};
		resourceRetrieveDataByFile(payload);
	};

	const { isPending: isSubmitting, mutate: resourceRetrieveDataByFile } =
		useMutation({
			mutationFn: EmployeeService.employeeRetrieveData,
			onSuccess: (res: any | IServerError | IResponse) => {

				dispatch(setSelectedCSVInformationUI({ tag: "Employee", data: res }));
				let path = `/employee/draft`;
				navigate(path);
				setSnackbarData({
					open: true,
					message: "Success",
					severity: "success",
				});
				// }
			},
			onError: (err: any) => {
				setSnackbarData({
					open: true,
					message: err.message,
					severity: "error",
				});
			},
		});


	const onDownloadSampleFileButtonClickedHandler = async () => {
		(async () => {
			try {
				setIsLoading(true)
				const response: any = await EmployeeService.downloadEmployeeSampleFile(
					clientId,
					taxYear
				);
				if (response.status === 400) {
					setSnackbarData({
						open: true,
						message: response.data.message
							? response.data.message
							: "Something went wrong.",
						severity: "error",
					});
				} else {
					const filename = `sample_employee.xlsx`;
					saveXlsxAsFile(response, filename);
				}
			} catch { setIsLoading(false) } finally { setIsLoading(false) }
		})();
	}

	const onSnackbarClosed = (
		event: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === "clickaway") {
			return;
		}
		setSnackbarData(INITIAL_SNACKBAR_DATA);
	};

	const drawerMenuOptions = useSelector(
		(state: IAppState) => state.drawerMenu.menu
	);
	const expandedLabels = ["Employee"];
	const expandedEmployeeImportOrSetupItem = "Import";
	const enhanceData = (data: any[], parentLabel?: string): any[] => {
		return data.map((item) => {
			let isExpanded = expandedLabels.includes(item.label);
			if (
				parentLabel === "Employee" &&
				item.label === expandedEmployeeImportOrSetupItem
			) {
				isExpanded = true;
			}
			const enhancedItem = {
				...item,
				expanded: item.items ? isExpanded : false,
				items: item.items ? enhanceData(item.items, item.label) : undefined,
				path: item.label === expandedEmployeeImportOrSetupItem && "/employee/import",
			};
			return enhancedItem;
		});
	};
	useEffect(() => {
		// dispatch(
		//   setSelectedActivityLogActions({
		//     entityId1: "",
		//     entityId2: "",
		//     entityId3: "",
		//     screenName: CLIENT_LIST_SCREEN_SLUG,
		//     accountantName: "",
		//     activityType: "activity_type=delete",
		//     activityLogVisibility: true,
		//   })
		// );
		dispatch(setSelectedStickyNavBar({ isSticky: false }));


		if (drawerMenuOptions && drawerMenuOptions.length > 0) {
			const enhancedData = enhanceData(drawerMenuOptions);
			dispatch(setSelectedDrawerOptionsMenu({ menu: enhancedData }));
		}
	}, [drawerMenuOptions]);
	return (
		<>
			<BackdropCircularProgress
				open={isSubmitting || isLoading || isPendingPayFrequencyDDL}
				testId="import-resource-backdrop"
			/>
			{payFrequencyDDLItems && payFrequencyDDLItems.length ?
				<form onSubmit={handleSubmit}>
					<Box sx={{ width: "100%", marginTop: "2rem" }}>
						<Grid
							container
							rowSpacing={1}
							columnSpacing={{ xs: 1, sm: 2, md: 3 }}
						>
							<Grid size={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
								<Paper>
									<Box
										sx={{
											fontSize: "1rem !important",
											fontWeight: "bold",
											padding: "1.25rem 16px 16px 16px",
										}}
									>
										Import Employee
									</Box>
									{/* <hr style={{
									borderColor: "rgba(0,0,0,.12)",
									border: "0",
									borderTop: "1px solid rgba(0,0,0,.1)",
									margin: 0,
								}} /> */}
									<Box sx={{ padding: "16px", height: "320px" }}>
										<Grid container>
											<Grid
												size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}
												sx={{ p: "12px" }}
											>
												<Typography
													sx={{
														color: "rgba(0,0,0,.6)",
														fontSize: ".875rem",
														p: "12px",
													}}
												>
													Import Employee
												</Typography>
											</Grid>
											<Grid
												size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
												sx={{ p: "12px" }}
											>
												<Box sx={{ p: "12px" }}>
													<input
														accept=".csv"
														type="file"
														onChange={handleFileChange}
														style={{ color: "rgba(0,0,0,.6)" }}
													/>
													<Typography
														variant="body2"
														sx={{ pt: "8px", color: "rgba(0,0,0,.6)" }}
													>
														Please upload .csv file.
													</Typography>
												</Box>
											</Grid>
										</Grid>
										<Grid container>
											<Grid
												size={{ xs: 12, sm: 12, md: 5, lg: 5, xl: 5 }}
												sx={{
													p: "12px", mt: "20px", "& .p-button-secondary .MuiSvgIcon-root": { marginRight: "10px", marginLeft: "-13px" },
													"& .p-button-secondary": { padding: "0.3rem 1.59375rem!important" }
												}}
											>
												{/* <DownloadFileButton
												text={"Download Sample File"}
												icon={<DownloadIcon />}
												testId={"download-file-button"}
												fileName={"sample_employee.xlsx"}
												base64={EXCEL_EMP_FILE_BASE64}
											/> */}

												<EnhancedButtonPrimeReact
													label="Download Sample File"
													icon={<DownloadIcon />}
													raised
													severity={EnhancedButtonPrimeReactSeverity.Secondary}
													onClickHandler={onDownloadSampleFileButtonClickedHandler}
												/>
											</Grid>
											<Grid
												size={{ xs: 12, sm: 12, md: 7, lg: 7, xl: 7 }}
												sx={{ p: "12px", mt: "20px" }}
											>
												<EnhancedButtonPrimeReact
													label="Retrieve data"
													type="submit"
													raised
													severity={EnhancedButtonPrimeReactSeverity.Success}
												/>
											</Grid>
										</Grid>
									</Box>
								</Paper>
							</Grid>
							<Grid size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}>
								<ImportSlipsInstructions
									instructions={instructionList}
									title={instructionTitle}
									subTitle={instructionSubTitle}
									testId="t4-slip-import-instructions"
								/>
							</Grid>
						</Grid>
					</Box>
					<EnhancedSnackbar
						message={snackbarData.message}
						onCloseHandler={onSnackbarClosed}
						severity={snackbarData.severity}
						testId={"resource-list-snackbar"}
						open={snackbarData.open}
					/>
				</form> : payFrequencyDDLItems && payFrequencyDDLItems.length === 0 ? <>
					<EnhancedSnackbarForLinkMessage
						message={(
							<>
								Save payroll schedule before creating new employee.{" "}
								<Link
									to={`/company/payroll-schedule`}
									className="no-underline"
									style={{ color: theme.palette.primary.light }}
								>
									click here
								</Link>
							</>
						)}
						onCloseHandler={onSnackbarClosed}
						severity={"warning"}
						testId={"snackbar"}
						open={true}
						autoHide={false}
					/>
				</> : <></>}
		</>
	);
};

export default EmployeeImportLayout;
